import React from 'react'
import classNames from 'classnames'

import { Icon } from '@scentregroup/ui'

import style from './index.scss'

type Props = {
  className?: string
  showSearch: () => void
}

const SearchBar: React.FC<Props> = ({ className, showSearch }) => (
  <div className={classNames(className, style.search)} aria-label="Search">
    <button onClick={showSearch}>
      <Icon size="medium" type="search" className={classNames(style.icon)} />
    </button>
    <input placeholder="Stores, products and more" onClick={showSearch} />
  </div>
)

export default SearchBar
